import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-bell-02',
  imports: [],
  templateUrl: './bell-02.html',
  styleUrl: './bell-02.scss',
})
export class Bell02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
